/* eslint-disable import/no-anonymous-default-export */
export default (history = [], action) => {
  switch (action.type) {
    case "GET_HISTORY_DEFAULT":
      return action.payload;

    default:
      return history;
  }
};
